// API Configuration
// W produkcji używamy tego samego hosta, w development localhost:5000
const API_BASE_URL = process.env.NODE_ENV === 'production'
    ? '' // Pusta ścieżka = ten sam host co aplikacja
    : (process.env.REACT_APP_API_URL || 'http://localhost:5000');

export const API_ENDPOINTS = {
    // Auth
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    LOGOUT: `${API_BASE_URL}/api/auth/logout`,

    // Flights
    FLIGHTS: `${API_BASE_URL}/api/flights`,
    FLIGHTS_REFRESH: `${API_BASE_URL}/api/flights/refresh`,
    FLIGHTS_STATS: `${API_BASE_URL}/api/flights/stats`,
    FLIGHTS_SYNC_INFO: `${API_BASE_URL}/api/flights/sync-info`,
    FLIGHTS_SEARCH: `${API_BASE_URL}/api/flights/search`,

    // Airports
    AIRPORTS_SEARCH: `${API_BASE_URL}/api/airports/search`,

    // Health
    HEALTH: `${API_BASE_URL}/api/health`,
};

export const fetchConfig = {
    credentials: 'include',
    headers: {
        'Content-Type': 'application/json',
    },
};

export default API_BASE_URL;
